import useStore from '../../../store'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Wizard, WizardHeader, WizardWorkflow } from '../../ui/wizard'
import AuditUnitSteps from './AuditUnitSteps'
import AuditUnitFormData from './AuditUnitFormData'

export default function AuditUnit() {
  const { fieldAuditId, auditUnitId } = useParams()
  const navigate = useNavigate()

  const setTopNavHidden = useStore((state) => state.setTopNavHidden)
  const fieldAuditUnits = useStore((state) => state.fieldAuditUnits)
  const updateAuditUnit = useStore((state) => state.updateAuditUnit)
  const user = useStore((state) => state.user)

  const [isEditing, setIsEditing] = useState(false)
  const [currentStep, setCurrentStep] = useState(0)
  const [auditUnit, setAuditUnit] = useState(null)
  const [auditData, setAuditData] = useState({
    id: auditUnitId,
    field_audit_id: fieldAuditId,
    images: {
      'Driver Side Front': null,
      'Passenger Side Rear': null,
      'Dash VIN': null
    }
  })

  useEffect(() => {
    const auditUnit = fieldAuditUnits.data.find((unit) =>
      unit.id === auditUnitId
    )
    setAuditUnit(auditUnit)
    setAuditData({
      ...auditData,
      can_refloor: auditUnit.attributes['can-refloor'] ? '1' : '0',
      current_sold: String(auditUnit.attributes['current-sold'] ?? auditUnit.attributes['sold']),
      current_date_sold: auditUnit.attributes['current-date-sold'] ?? auditUnit.attributes['sold-on']
    })
  }, [auditUnitId])

  useEffect(() => {
    setTopNavHidden(true)

    return () => {
      setTopNavHidden(false)
    }
  }, [currentStep])

  const getSteps = () => AuditUnitSteps({
    auditUnit: auditUnit,
    auditData: auditData,
    setAuditData: setAuditData,
    setIsEditing: setIsEditing,
  })

  const goToFieldAudit = () => {
    navigate(`/field_audits/${fieldAuditId}`)
  }

  const handleBack = () => {
    if (currentStep <= 0) {
      goToFieldAudit()
    } else {
      setCurrentStep(currentStep - 1)
    }
  }

  const handleNextStep = () => {
    if (isEditing) {
      setIsEditing(false)
      setCurrentStep(getSteps().length - 1)
    } else {
      setCurrentStep(currentStep + 1)
    }
  }

  const handleComplete = async () => {
    const formData = await AuditUnitFormData({ auditData, user })

    await updateAuditUnit(
      fieldAuditId,
      auditUnitId,
      formData,
      () => {
        goToFieldAudit()
      }
    )
  }

  return (
    <Wizard>
      <WizardHeader
        title="Audit Unit"
        progress={((currentStep + 1) / getSteps().length * 100)}
        showBackButton
        handleBack={handleBack}
      />
      <WizardWorkflow
        getSteps={getSteps}
        dependencies={[auditUnit, auditData, auditData.condition, auditData.images]}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        handleNextStep={handleNextStep}
        onComplete={handleComplete}
      />
    </Wizard>
  )
}